import { axiosBase } from '../../api/axios-base';

const state = {
  clusters: [],
  selectedCluster: [],
  filteredClusters: [],
};
const getters = {
  CLUSTERS: (state) => {
    return state.filteredClusters.length == 0
      ? state.clusters
      : state.filteredClusters;
  },
  CLUSTERS_COUNTER: (state) => {
    return state.clusters.length;
  },
  SELECTED_CLUSTER: (state) => {
    return state.selectedCluster;
  },
};
const mutations = {
  SET_CLUSTERS: (state, payload) => {
    state.clusters = payload;
  },
  SET_SELECT_CLUSTER: (state, payload) => {
    state.selectedCluster = payload;
  },
  SET_FILTERED_CLUSTERS: (state, payload) => {
    state.filteredClusters = payload;
  },
};
const actions = {
  GET_CLUSTERS: async (context, parameters) => {
    let { data } = await axiosBase.get(
      "/api/v1/filter/cluster/",
     { params: {
        location: parameters.location,
        status: parameters.status
      }}
    );
    context.commit("SET_CLUSTERS", data);
  },
  GET_CLUSTER: async (context, idx) => {
    let { data } = await axiosBase.get(
      "/api/v1/clusterdetail/" + idx + "/"
    );
    context.commit("SET_FOCUS_COORD", {zoom: 10, center: data.central_point});
    context.commit("SET_SELECT_CLUSTER", data);
  },

};

export default {
  state,
  getters,
  mutations,
  actions,
};
